import { render } from "./LinkStatSettings.vue?vue&type=template&id=4c5fddfb&scoped=true"
import script from "./LinkStatSettings.vue?vue&type=script&lang=js"
export * from "./LinkStatSettings.vue?vue&type=script&lang=js"

import "./LinkStatSettings.vue?vue&type=style&index=0&id=4c5fddfb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5fddfb"]])

export default __exports__